import React from 'react';

import { Icon, OnClick } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { BackArrowLink } from 'components/navigation/back-arrow';
import useMediaQuery from 'hooks/use-media-query';
import { useMatch } from 'state/location';
import { routes } from 'utils/routing';

interface IProps {
  url?: string;
  onClick?: OnClick;
}

const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-size: 16px;
  font-weight: ${Styles.fontWeight.heavy};
  padding: 8px 16px;
  border-radius: 999px;
  transition: background-color 0.2s, color 0.2s;

  svg {
    width: 1rem;
    height: 1rem;
    fill: #000;
  }

  &:hover {
    background-color: ${Styles.color.grey.four};
  }

  &:active {
    background-color: ${Styles.color.black};
    color: ${Styles.color.white};

    svg {
      color: ${Styles.color.white};
      fill: ${Styles.color.white};
    }
  }
`;

const MainMenuLink: React.FC<IProps> = ({ url, onClick }) => {
  const { formatMessage } = useIntl();
  const isDesktop = useMediaQuery('desktop');
  const isMainMenu = useMatch(formatMessage({ id: routes.menu }));

  return isDesktop ? (
    <StyledLink to={url || routes.menu} onClick={onClick as any}>
      <Icon icon="previous" color="primary" width="16px" aria-hidden />
      {formatMessage({ id: 'mainMenu' })}
    </StyledLink>
  ) : isMainMenu ? null : (
    <BackArrowLink to={url || routes.menu} />
  );
};

export default MainMenuLink;
